import React from 'react';
import Terms from '../defaults/Terms';

export default (props) => {
  return (
    <Terms />
  );
}
